import { render, staticRenderFns } from "./form-component.vue?vue&type=template&id=76db450f&scoped=true"
import script from "./form-component.vue?vue&type=script&lang=js"
export * from "./form-component.vue?vue&type=script&lang=js"
import style0 from "./form-component.vue?vue&type=style&index=0&id=76db450f&lang=less"
import style1 from "./form-component.vue?vue&type=style&index=1&id=76db450f&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76db450f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76db450f')) {
      api.createRecord('76db450f', component.options)
    } else {
      api.reload('76db450f', component.options)
    }
    module.hot.accept("./form-component.vue?vue&type=template&id=76db450f&scoped=true", function () {
      api.rerender('76db450f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/compoment/form-component/form-component.vue"
export default component.exports